// var global = global || {};

(function ($, root, undefined) {

  $(function () {

    'use strict';

    global.initSite = () => {
      let timer = setTimeout(() => {
        clearTimeout(timer);

        initOwlCarousel();
        initOwlCarouselSLiderClient();

        fixeNav();

        reRenderRecaptcha();

        sendGoogleAnalyticsData();

        scrollReveal();

        toggleActuHome();

        // animOnPage();
      });
    };

    function initToggleActuHome(){
      setTimeout(() => {
        $('.actuHome').addClass('open');
        setTimeout(() => {
          $('.actuHome').removeClass('open');
        }, 1000);
      }, 500);
    }
    initToggleActuHome();

    function toggleActuHome(){
      $('.buttonToggleActu').click(() => {
        if($('.actuHome').hasClass('open')){
          $('.actuHome').removeClass('open');
        } else {
          $('.actuHome').addClass('open');
        }
      });
    }

    function sendGoogleAnalyticsData(){
      ga('send', 'pageview', location.pathname);
    }

    function reRenderRecaptcha() {
      if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.render === 'function') {
        grecaptcha.render($('.g-recaptcha')[0], { sitekey: recaptchaKey });
      }
    }

    function fixeNav() {
      let $body = $("body");
      $(window).scroll(() => {
        let scroll = $(window).scrollTop();
        if ($('html').hasClass('no-touch')) {
          if (scroll >= 100) {
            $body.addClass("navFixed");
          } else {
            $body.removeClass("navFixed");
          }
        }
      });
    }

    function scrollReveal() {
      window.sr = ScrollReveal({ reset: true });

      sr.reveal('.effetRevealLeft', {
        duration: 600,
        delay: 300,
        scale: 1,
        mobile: false,
        useDelay: 'once',
        origin: 'left',
        distance: '100px',
        viewFactor: 0.3
      });

      sr.reveal('.effetRevealRight', {
        duration: 600,
        delay: 300,
        scale: 1,
        mobile: false,
        useDelay: 'once',
        origin: 'right',
        distance: '100px',
        viewFactor: 0.3
      });

      sr.reveal('.effetRevealTop', {
        duration: 600,
        delay: 300,
        scale: 1,
        mobile: false,
        useDelay: 'once',
        origin: 'top',
        distance: '100px',
        viewFactor: 0.3
      });

      sr.reveal('.effetRevealBottom', {
        duration: 600,
        delay: 300,
        scale: 1,
        mobile: false,
        useDelay: 'once',
        origin: 'top',
        distance: '100px',
        viewFactor: 0.3
      });

    }

    function initOwlCarousel() {
      let owl = $(".slider-owl-carousel").owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        // autoWidth: true,
        mouseDrag: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: false,
        nav: false,
        // navText: [ '<', '>' ],
        dots: true,
        smartSpeed: 700,
        responsiveClass: true,
        responsive: {
          0: {
            nav: false
          },
          600: {

          },
          979: {

          }
        }
      });
      owl.trigger('refresh.owl.carousel');
      window.dispatchEvent(new Event('resize'));

    }

    function initOwlCarouselSLiderClient() {
      let owl = $(".sliderClient-owl-carousel").owlCarousel({
        items: 5,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: false,
        nav: false,
        // navText: [ '<', '>' ],
        dots: false,
        smartSpeed: 700,
        responsiveClass: true,
        responsive: {
          0: {
            items: 2,
          },
          600: {
            items: 5,
          },
          979: {

          }
        }
      });
      owl.trigger('refresh.owl.carousel');
      window.dispatchEvent(new Event('resize'));

    }


    global.initSite();

  });

  // let interval;
  // function animOnPage() {
  //   if (typeof interval !== 'undefined') {
  //     clearInterval(interval);
  //   }

  //   interval = setInterval( () => {
  //     global.animBeez();
  //   }, 1000 * 30);
  // }

})(jQuery, this);






// from parent them

let global = {};

(function ($, root, undefined) {

  $(function () {

    'use strict';

    // https://github.com/miguel-perez/smoothState.js
    let $body = $('body');
    let $loader = $('#loader');
    let $transition = $('.beezLoader');

    let $page = $('#main'),
      options = {
        debug: true,
        blacklist: ".no-smoothstate, a[href*='.jpg'], a[href*='.png'], a[href*='.jpeg'], a[href*='.pdf']",
        prefetch: false,
        loadingClass: 'onload',
        scroll: true,
        cacheLength: 0,
        forms: 'search',
        onStart: {
          duration: 0, // Duration of our animation
          render:  ($container) => {
            smoothState.restartCSSAnimations();
            $body.addClass("beforeload");
          }
        },
        onProgress: {
          // How long this animation takes
          duration: 2000,
          // A function that dictates the animations that take place
          render: ($container) => {
            $body.removeClass("loaded");

            // global.animBeez();

            $body.removeClass("beforeload");
          }
        },
        onReady: {
          duration: 0,
          render: ($container, $newContent) => {

            $body.addClass("loaded");

            // Inject the new content
            $container.html($newContent);
            global.initSite();
          }
        },
        onAfter: ($container, $newContent) => {
          // $body.removeClass("onload");
          // $loader.removeClass("start");
        }
      },
      smoothState = $page.smoothState(options).data('smoothState');

    // -------- End smoothState ------------

    // global.animBeez = () =>{
    //   let $transition = $('.beezLoader');
    //   TweenMax.set($transition, { top: '80%', left: '0%' });
    //   TweenMax.to($transition, 3, {
    //     bezier: {
    //       curviness: Math.random() * (1 - 5 + 1) + 5,
    //       values: [
    //         {
    //           top: '80%',
    //           left: '0%'
    //         },
    //         {
    //           top: '20%',
    //           left: '30%'
    //         },
    //         {
    //           top: '65%',
    //           left: '75%'
    //         },
    //         {
    //           top: '0%',
    //           left: '100%'
    //         },
    //       ],
    //       ease: Power2.easeInOut,
    //       rotation: 260
    //     }
    //   });
    // };

    $('a:not([href])').click((e) => {
      e.preventDefault();
      window.location.href = '/';
    });

    $('.nav a').on('click', (e) => {
      $('#toggle-nav').removeAttr('checked');
    });


  });

})(jQuery, this);

(function ($, undefined) {
  let isFired = false;
  let oldReady = jQuery.fn.ready;
  $(function () {
    isFired = true;
    $(document).ready();
  });
  jQuery.fn.ready = (fn) => {
    if (fn === undefined) {
      $(document).trigger('_is_ready');
      return;
    }
    if (isFired) {
      window.setTimeout(fn, 1);
    }
    $(document).bind('_is_ready', fn);
  };
})(jQuery);
